import React from 'react';
import Link from 'next/link';
import Modal from '@common/modal';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface BookmarkModalProps {
  visible: boolean;
  onClose: () => void;
}

const BookmarkModal = ({ visible, onClose }: BookmarkModalProps) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <em className={cx('title')}>
          [지원현황] {'>'} 북마크에
          <br />
          저장되었어요.
        </em>

        <div className={cx('btnArea')}>
          <Link href={RouteUrl.MATCH} legacyBehavior>
            <a className={cx('btn', 'confirm')} role="button">
              북마크한 포지션 보기
            </a>
          </Link>
        </div>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default BookmarkModal;
